import { Link } from "react-router-dom";
import { PageMeta } from "@/components/site/PageMeta";

export default function PayCancel() {
    return (
        <>
            <PageMeta title="Payment Canceled — Nationwide Strategies LLC" description="Payment canceled." />
            <section data-testid="pay-cancel-page" className="pt-32 sm:pt-40">
                <div className="mx-auto max-w-2xl px-4 pb-28 sm:px-6">
                    <h1 className="font-serif text-4xl font-medium tracking-tight text-slate-100">Payment canceled.</h1>
                    <p data-testid="pay-cancel-message" className="mt-6 text-sm leading-relaxed text-slate-400">
                        No charge was made. You can return to the payments page whenever you are ready.
                    </p>
                    <Link
                        to="/pay"
                        data-testid="pay-cancel-back-link"
                        className="mt-12 inline-flex items-center gap-3 border border-slate-700 px-8 py-4 font-mono text-[11px] uppercase tracking-[0.25em] text-slate-200 transition-colors duration-300 hover:border-blue-500 hover:text-white"
                    >
                        Back to Client Payments
                    </Link>
                </div>
            </section>
        </>
    );
}
